module.exports = __webpack_public_path__ + "f821d29c1ad9ebcd0bcc85d54e30694c.svg";